import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ActorsList, { ActorsProps } from '@avatar/components/ActorsList';
import { ProjectFragment } from '../../fragments.generated';
import Tooltip from '../../Tooltip';
import StudioPhoneticLibrary from './StudioPhoneticLibrary';
import { setReplacementsState } from '../../../store/ReplacementsSlice';
import { useAppDispatch } from '../../../store/hooks';

interface StudioScriptOptionsProps {
  project: ProjectFragment;
  isPhoneticLibraryEnabled: boolean;
  setActiveActor: ActorsProps['setActiveActor'];
  isDesktop: boolean;
  desktopActorLimit: number;
  actor?: ActorsProps['activeActor'];
  actorVariant?: ActorsProps['activeActorVariant'];
  tags?: ActorsProps['tags'];
  replacementsDisabled: boolean;
}

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(3, 2.5, 1.25, 2.5),
  },
  divider: {
    marginLeft: -20,
    marginRight: -20,
  },
  sectionHeader: {
    fontSize: theme.spacing(1.75),
    lineHeight: 'normal',
    textTransform: 'capitalize',
  },
  replacementsLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tooltip: {
    maxWidth: 210,
    position: 'relative',
    top: theme.spacing(3.125),
  },
}));

const StudioScriptOptions = (props: StudioScriptOptionsProps) => {
  const {
    project,
    isPhoneticLibraryEnabled,
    setActiveActor,
    isDesktop,
    actor,
    actorVariant,
    desktopActorLimit,
    tags,
    replacementsDisabled,
  } = props;

  const { classes } = useStyles();

  const appDispatch = useAppDispatch();

  useEffect(() => {
    appDispatch(
      setReplacementsState({
        replacementsEnabled: isPhoneticLibraryEnabled,
      })
    );
  }, [appDispatch, isPhoneticLibraryEnabled]);

  return (
    <div className={classes.root}>
      <Tooltip
        text={
          replacementsDisabled
            ? 'Replacements are not available for this language.'
            : ''
        }
        placement="left"
        disabled={replacementsDisabled === false}
        classes={{ tooltip: classes.tooltip }}
      >
        <Box>
          {isPhoneticLibraryEnabled && (
            <StudioPhoneticLibrary
              project={project}
              replacementsDisabled={replacementsDisabled}
            />
          )}
        </Box>
      </Tooltip>
      <Box marginTop={!isPhoneticLibraryEnabled ? 0.5 : 4}>
        <ActorsList
          project={project}
          activeActor={actor}
          activeActorVariant={actorVariant}
          setActiveActor={setActiveActor}
          limit={isDesktop ? desktopActorLimit : undefined}
          tags={tags}
        />
      </Box>
    </div>
  );
};

export default StudioScriptOptions;
